"use client";
import React, { useState, useEffect } from "react";
import Image from "next/image";
import { site } from "@/data/default";
import Link from "next/link";

const CounDown = () => {
  const [days, setDays] = useState(0);
  const [hours, setHours] = useState(0);
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(0);

  const deadline = "December, 31, 2025";

  const getTime = () => {
    const time = Date.parse(deadline) - Date.now();

    setDays(Math.floor(time / (1000 * 60 * 60 * 24)));
    setHours(Math.floor((time / (1000 * 60 * 60)) % 24));
    setMinutes(Math.floor((time / 1000 / 60) % 60));
    setSeconds(Math.floor((time / 1000) % 60));
  };

  useEffect(() => {
    // @ts-ignore
    const interval = setInterval(() => getTime(deadline), 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="overflow-hidden py-20">
      <div className="max-w-[1170px] w-full mx-auto px-4 sm:px-8 xl:px-0">
        <div className="relative overflow-hidden z-1 rounded-lg bg-[#f0d2fb] p-4 sm:p-7.5 lg:p-10 xl:p-15">
          <div className="max-w-[422px] w-full">
            <span className="block font-medium text-custom-1 text-purple-800 mb-2.5">
              Penawaran Terbatas
            </span>

            <h2 className="heading uppercase tracking-tight font-bold text-dark text-xl lg:text-heading-4 mb-3">
              Sewa Panggung, Sound System, & Alat Band Lengkap
            </h2>

            <p className="text-dark">Panggungmu, Aksimu, Suaramu!<br />Panggung, sound system, dan alat band lengkap buat bikin acara kamu makin keren. Cocok untuk konser, pensi, wedding, atau event kantor.</p>

            {/* <!-- Countdown timer --> */}
            <div
              className="flex heading flex-wrap gap-4 mt-6"
              x-data="timer()"
              x-init="countdown()"
            >
              {/* <!-- timer day --> */}
              <div>
                <span
                  className="min-w-[64px] h-14.5 font-semibold text-xl lg:text-3xl text-dark rounded-lg flex items-center justify-center bg-white shadow-2 px-4 mb-2"
                  x-text="days"
                >
                  {" "}
                  {days < 10 ? "0" + days : days}{" "}
                </span>
                <span className="block text-custom-sm text-dark text-center">
                  Hari
                </span>
              </div>

              {/* <!-- timer hours --> */}
              <div>
                <span
                  className="min-w-[64px] h-14.5 font-semibold text-xl lg:text-3xl text-dark rounded-lg flex items-center justify-center bg-white shadow-2 px-4 mb-2"
                  x-text="hours"
                >
                  {" "}
                  {hours < 10 ? "0" + hours : hours}{" "}
                </span>
                <span className="block text-custom-sm text-dark text-center">
                  Jam
                </span>
              </div>

              {/* <!-- timer minutes --> */}
              <div>
                <span
                  className="min-w-[64px] h-14.5 font-semibold text-xl lg:text-3xl text-dark rounded-lg flex items-center justify-center bg-white shadow-2 px-4 mb-2"
                  x-text="minutes"
                >
                  {minutes < 10 ? "0" + minutes : minutes}{" "}
                </span>
                <span className="block text-custom-sm text-dark text-center">
                  Menit
                </span>
              </div>

              {/* <!-- timer seconds --> */}
              <div>
                <span
                  className="min-w-[64px] h-14.5 font-semibold text-xl lg:text-3xl text-dark rounded-lg flex items-center justify-center bg-white shadow-2 px-4 mb-2"
                  x-text="seconds"
                >
                  {seconds < 10 ? "0" + seconds : seconds}{" "}
                </span>
                <span className="block text-custom-sm text-dark text-center">
                  Detik
                </span>
              </div>
            </div>
            {/* <!-- Countdown timer ends --> */}

            <Link
              href={`https://wa.me/${site.whatsapp}?text=${encodeURIComponent(
                `Hai ${site.name},\nsaya minta penawaran khusus bisnis sewa untuk sewa panggung, sound system, dan alat band.`
              )}`}
              target="_blank"
              rel="noopener noreferrer"
              title="Sewa Panggung, Sound System, dan Alat Band untuk Bisnis, Sekolah, Event, dan Lainnya"
              className="inline-flex font-medium text-custom-sm text-white bg-purple-700 py-3 px-9.5 rounded-md ease-out duration-200 hover:bg-purple-800 mt-7.5"
            >
              Check it Out!
            </Link>
          </div>

          {/* <!-- bg shapes --> */}
          <Image
            src="/images/countdown/countdown-bg.png"
            alt="bg shapes"
            className="hidden sm:block h-full absolute right-0 bottom-0 -z-1 w-auto"
            width={737}
            height={482}
          />
          <Image
            src="/images/products/sewa-sound-system-alat-band.webp"
            alt="product"
            className="hidden md:block absolute right-4 xl:right-33 bottom-4 xl:bottom-10 -z-1 w-[40%] h-auto"
            width={640}
            height={640}
          />
        </div>
      </div>
    </section>
  );
};

export default CounDown;
